import { Box, Grid, Typography, Icon } from "@mui/material";
import { useEffect, useState } from "react";
import DateTimeDisplay from "./dateTimeDisplay";
import ThemeToggleButton from "../components/themeButton";
import LanguageButton from "../components/langButton";
import useServerStatusAdmin from "../hooks/useAdminServerStatus";
import useActiveTimeSlot from "../hooks/useActiveTimeSlot";
import NavigatorLogo from "../images/Vector (Navigator bar).svg";
import ServerOn from "../images/Icon Left (Server ON).svg";
import ServerOff from "../images/Icon Left (Server OFF).svg";
import LogoutSuperAdmin from "./logoutSuperAdmin";
import { useTranslation } from "react-i18next";

export default function TopBar({ title = "SuperAdmin Dashboard" }) {
  const isServerOnline = useServerStatusAdmin(`/api/admin/ping`);
  const activeTimeSlot = useActiveTimeSlot();
  const [bg, setBg] = useState("#D8FFE5");
  const [border, setBorder] = useState("#125605");
  const [icon, setIcon] = useState(ServerOn);
  const { t } = useTranslation();

  useEffect(() => {
    if (isServerOnline) {
      setBg("#D8FFE5");
      setBorder("#125605");
      setIcon(ServerOn);
    } else {
      setBg("#FFDEDE");
      setBorder("#E00C0C");
      setIcon(ServerOff);
    }
  }, [isServerOnline]);

  return (
    <Box display="flex" alignItems="center" sx={{ px: "1.719vw", height: "5vh" }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item display="flex" alignItems="center" sx={{ gap: 1.5 }}>
          <div style={{ paddingRight: "1.146vw" }}>
            <img src={NavigatorLogo} alt="Logo" />
          </div>

          <Typography fontSize="16px" lineHeight="175%" fontWeight="bold">
            {title}
          </Typography>

          <DateTimeDisplay />

          <Box
  sx={{
    px: 1.5,
    py: 0.5,
    bgcolor: "#f59e0b",
    color: "#111",
    borderRadius: "999px",
    fontWeight: 700,
    fontSize: "12px",
    ml: 1,
    display: "inline-flex",
    alignItems: "center",
    minHeight: "28px",
  }}
>
  {activeTimeSlot}
</Box>
        </Grid>

        <Grid item display="flex" alignItems="center">
          <Typography
            color="black"
            display="flex"
            alignItems="center"
            sx={{
              fontSize: "14px",
              border: `1px solid ${border}`,
              borderRadius: "8px",
              background: bg,
              px: 2,
              py: 0.5,
            }}
          >
            {t("server")}
            <Icon sx={{ pl: 1 }}>
              <img src={icon} alt="Server status" style={{ marginBottom: "6px" }} />
            </Icon>
          </Typography>

          <ThemeToggleButton />
          <LanguageButton />
          <LogoutSuperAdmin />
        </Grid>
      </Grid>
    </Box>
  );
}